import { Link } from 'react-router-dom';
import { useState, useCallback } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('请输入有效的邮箱地址');
      return;
    }
    setError('');
    setLoading(true);

    try {
      const form = e.currentTarget as HTMLFormElement;
      const formData = new FormData(form);

      const honeypot = (formData.get('phone_alt') as string || '').trim();
      if (honeypot) {
        setSubscribed(true);
        setEmail('');
        setLoading(false);
        return;
      }

      const res = await fetch('https://readdy.ai/api/form/d9qmp6ue3oq4jqumtn60', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Object.fromEntries(
            Array.from(formData.entries()).filter(([_, v]) => typeof v === 'string')
          ) as Record<string, string>
        ).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubscribed(true);
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setError(msg);
      }
    } catch {
      setError('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  }, [email]);

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-gift-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                福利导航
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              一站式福利资源聚合平台，让每一分钱都花得值。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/youhuiquan" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">优惠券</Link>
              <Link to="/category/huiyuanyiquan" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">会员权益</Link>
              <Link to="/category/shenghuobutie" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">生活补贴</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              更多分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/zhichangfuli" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">职场福利</Link>
              <Link to="/category/jiuyuefuli" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">教育福利</Link>
              <Link to="/category/jiankangfuli" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">健康福利</Link>
              <Link to="/category/lvyoufuli" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">旅游福利</Link>
              <Link to="/category/jinrongfuli" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">金融福利</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              订阅周报
            </h4>
            <p className="text-sm text-background-400 mb-3">
              每周精选福利推送，不错过任何福利机会。
            </p>
            {subscribed ? (
              <p className="text-sm text-accent-400 font-medium">
                <i className="ri-check-double-line mr-1"></i>订阅成功！感谢关注。
              </p>
            ) : (
              <form onSubmit={handleSubscribe} data-readdy-form="true">
                <div className="hp-field">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <div className="flex gap-2">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(''); }}
                    placeholder="输入邮箱地址"
                    className="flex-1 px-3 py-2 text-sm bg-background-800 border border-background-700 rounded-md text-background-100 placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
                    required
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    className="px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
                  >
                    {loading ? '提交中...' : '订阅'}
                  </button>
                </div>
                {error && <p className="text-sm text-primary-400 mt-2">{error}</p>}
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-500">
            &copy; 2026 福利导航 fulidaohang.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">使用条款</a>
            <a href="/about" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}